import { Tooltip } from "@mui/material";
import { useState } from "react";
import { CountResult } from "../types";
import { fmtCount } from "../utils";
import useLang from "Shared/hooks/useLanguage";

interface Props {
  count: CountResult | null;
  loadedCount: number;
  sortLabel: string | null;
  countsUpdatedAt: number | null;
  onRefreshCounts: () => Promise<void> | void;
}

const WorklistMeta = ({
  count,
  loadedCount,
  sortLabel,
  countsUpdatedAt,
  onRefreshCounts,
}: Props) => {
  const { t } = useLang();
  const [refreshing, setRefreshing] = useState(false);
  const age =
    countsUpdatedAt === null
      ? null
      : Math.round((Date.now() - countsUpdatedAt) / 1000);

  const handleRefresh = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      await onRefreshCounts();
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <div className="vr2-meta">
      <span>
        <b>{fmtCount(count?.total, count?.isCapped)}</b> {t("results")} ·{" "}
        <b>{loadedCount.toLocaleString("en-US")}</b> {t("loaded")}
        {sortLabel && (
          <>
            {" · "}
            {t("sorted by")} {sortLabel}
          </>
        )}
      </span>
      <span className="d-flex align-items-center gap-1">
        {t("Tab counts")}{" "}
        {age === null ? t("loading") : `${t("updated")} ${age}s ${t("ago")}`}
        <Tooltip title={t("Refresh counts")} arrow placement="top">
          <button
            type="button"
            className="btn btn-icon btn-sm h-20px w-20px btn-active-light-primary"
            onClick={handleRefresh}
            disabled={refreshing}
            aria-label={t("Refresh counts")}
          >
            <i className={`bi bi-arrow-clockwise fs-7${refreshing ? " vr2-spin" : ""}`}></i>
          </button>
        </Tooltip>
      </span>
    </div>
  );
};

export default WorklistMeta;
